const state = {
  modalContent: {},
  showQuickShop: false,
  variant:{}
}

const root = { root: true };

const actions = {

  setQuickShop: async ({ commit, rootState }, payload) => {
    const req = await fetch(`/products/${payload.product}?view=json`);
    const model = await req.json();
    const shapedPayload = { ...payload, product: model };
    
    const reqMeta = await fetch(`/products/${payload.product}?view=quickshop`);
    const metafields = await reqMeta.json();
    const shapedPayloadwithMeta = { ...shapedPayload, customFields: metafields };

    commit('SET_QUICKSHOP', shapedPayloadwithMeta);
    commit('SET_VARIANT', shapedPayload.product.selected_or_first_available_variant);
    commit('SET_VISIBILITY', true);
  },

  closeQuickShop: ({ commit, dispatch, state }) => {
    commit('SET_VISIBILITY', false);
  },

  setVariant: async ({ commit }, payload) => {
    commit('SET_VARIANT', payload);
  }
}

const mutations = {

  SET_QUICKSHOP: (state, payload) => {
    state.modalContent = payload;
  },

  SET_VISIBILITY: (state, payload) => {
    state.showQuickShop = payload;
  },

  SET_VARIANT: (state, payload) => {
    state.variant = payload;
  }
}

export default { namespaced: true, state, mutations, actions }